import { useContext } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { Button } from '@components/ButtonV2';
import { Container } from '@components/layout/Grid';
import { Title } from '@ecosystems/landing_pages/hero/components';
import { BundleQuery } from '@gql/generated';
import LanguageContext from '@lib/contexts/languageContext';
import { UserContext } from '@lib/contexts/UserProvider';
import PaymentHandler from '@organisms/modals/payment/PaymentHandler';

const Section = styled.div<{ imgUrl: string }>`
  background-image: url('${({ imgUrl }) => imgUrl}');
  background-size: cover;
`;

type Props = {
  content: BundleQuery['bundle']['promotionSection'];
  promotionSubscription: BundleQuery['bundle']['subscriptionPromotion'];
  onPaymentComplete(): void;
};

export const PromotionSection = ({
  content,
  promotionSubscription,
  onPaymentComplete,
}: Props) => {
  const lang = useContext(LanguageContext);
  const [currentUser] = useContext(UserContext);
  const router = useRouter();

  return (
    <Container py={40} px={20} fullWidth>
      <Section
        imgUrl={content?.image || '/static/homepage_hero.jpg'}
        className="w-full max-w-[1280px] flex items-center justify-center min-h-[50vh] mx-auto p-6 md:p-14 scroll-m-40 rounded-[8px]"
        id="Section--Promotion"
      >
        <div className="w-full flex flex-col justify-center gap-2 text-white">
          <Title
            as="h2"
            className="!text-white !text-3xl !mb-0 !md:text-[34px]"
          >
            {content.title}
          </Title>
          <div
            className="text-base text-white max-w-2xl"
            dangerouslySetInnerHTML={{
              __html: content.content,
            }}
          ></div>
          <div className="">
            <PaymentHandler
              sourcePage="subscriptions"
              code={promotionSubscription?.code}
              paymentType={promotionSubscription?.subscriptionName}
              amount={promotionSubscription?.amount}
              currency={promotionSubscription?.currency}
              redirectToSuccess={`/${lang}/me/dashboard`}
              redirectToFailed={`/${lang}/subscription/payment?paymentType=${
                promotionSubscription?.subscriptionName
              }`}
              months={promotionSubscription?.months}
              onPaymentComplete={(data) => {
                // onPaymentCompleted(data, { amount: amountToPay, currency });
                onPaymentComplete();
              }}
              data-testid="registration.payment.paymentModal"
            >
              {(makePayment) => {
                return (
                  <Button
                    onClick={() => {
                      if (currentUser?.id) {
                        makePayment();
                      } else {
                        router.push({
                          pathname: `/${lang}/register/account`,
                          query: {
                            code: promotionSubscription?.code,
                            paymentType: promotionSubscription.subscriptionName,
                          },
                        });
                      }
                    }}
                  >
                    {content.buttonContent}
                  </Button>
                );
              }}
            </PaymentHandler>
          </div>
        </div>
      </Section>
    </Container>
  );
};
